import RegistrationForm from "./RegistrationForm";

interface DealerRegistrationFormProps {
  onBack: () => void;
  onSubmit: (data: Record<string, unknown>) => void;
  isLoading?: boolean;
  error?: string;
  nameFromBankId?: boolean;
}

const DealerRegistrationForm = ({
  onBack,
  onSubmit,
  isLoading = false,
  error,
  nameFromBankId = false,
}: DealerRegistrationFormProps) => {
  return (
    <RegistrationForm
      onBack={onBack}
      onSubmit={onSubmit}
      isLoading={isLoading}
      error={error}
      userType="dealer"
      nameFromBankId={nameFromBankId}
    />
  );
};

export default DealerRegistrationForm;
